import { render, staticRenderFns } from "./TkRecommendHotelList.vue?vue&type=template&id=1cf9b9f0&"
import script from "./TkRecommendHotelList.vue?vue&type=script&lang=js&"
export * from "./TkRecommendHotelList.vue?vue&type=script&lang=js&"
import style0 from "./TkRecommendHotelList.vue?vue&type=style&index=0&id=1cf9b9f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports